import './product.scss'

import {useState} from 'react'
import {Carousel} from 'antd';
import companyUtil from "../../utils/companyUtil";

var React = require("react")


//我的产品
const Product: React.FunctionComponent = () => {

    /*data列表
        name:列表名称
        imgIcon:顶部图标
        backImg:背景图片
        descText:描述文件
    */
    const [tabList] = useState<Array<{ name: string, icon: string, image: string, content: string, link: string }>>(companyUtil.app);
    //定义当前所在的下标
    const [currentIndex, setCurrentIndex] = useState(0);
    //判断左右切换组件是否hover
    const [isLeftHover, setIsLeftHover] = useState<boolean>(true);
    const [isRightHover, setIsRightHover] = useState<boolean>(true);
    //判断imgIcon是否hover
    const [isImgIconHover, setIsImgIconHover] = useState<number | null>(null);
    //Carousel的ref对象
    const varousel = React.useRef();


    /**
     * 切换到下一张
     */
    const next = (val: any) => {
        let index = currentIndex + 1;
        if (index >= tabList.length) {
            index = 0
        }
        setCurrentIndex(index)
        varousel.current.next();
    }

    /**
     * 切换到上一张
     */
    const prev = () => {
        let index = currentIndex - 1;
        if (index < 0) {
            index = tabList.length - 1;
        }
        setCurrentIndex(index)
        varousel.current.prev();
    }

    const goIndex = (index: number) => {
        setCurrentIndex(index)
        varousel.current.goTo(index);
    }

    return (
        <div className="productBox" style={{"height": window.innerHeight - 100 + 'px'}}>
            <div className="contentBox">
                <p className="title">我的产品</p>
                <div className="tabBar">
                    {
                        tabList.map((item, index) => {
                            return (
                                <div className="imgIconBox">
                                    <img
                                        onMouseEnter={() => setIsImgIconHover(index)}
                                        onMouseLeave={() => setIsImgIconHover(null)}
                                        onClick={() => goIndex(index)}
                                        className={
                                            currentIndex == index ?
                                                "imgIconHover"
                                                :
                                                isImgIconHover == index ?
                                                    "imgIconHover"
                                                    :
                                                    "imgIcon"
                                        }
                                        src={item.icon}
                                        alt=""
                                    />
                                </div>
                            )
                        })
                    }
                </div>
                <div className="dotsBoxBtn"
                >
                    <div className="leftIconBox"
                         onMouseEnter={() => setIsLeftHover(false)}
                         onMouseLeave={() => setIsLeftHover(true)}
                         onClick={() => prev()}
                    >
                        <img
                            className="IconImg"
                            src={
                                !!isLeftHover ?
                                    require('./../assets/icon/switch_left_uncheck.png').default
                                    :
                                    require('./../assets/icon/switch_left_check.png').default
                            } alt=""/>
                    </div>
                    <div className="leftIconBox"
                         onMouseEnter={() => setIsRightHover(false)}
                         onMouseLeave={() => setIsRightHover(true)}
                         onClick={(val) => next(val)}
                    >
                        <img
                            className="IconImg"
                            src={
                                !!isRightHover ?
                                    require('./../assets/icon/switch_right_uncheck.png').default
                                    :
                                    require('./../assets/icon/switch_right_check.png').default
                            } alt=""/>
                    </div>
                </div>
                <Carousel
                    effect="scrollx"
                    dots={false}
                    draggable={true}
                    ref={varousel}
                >
                    {tabList.map((item, index) => {
                        return (
                            <div key={index} className="itemBox">
                                <div className="itemContent">
                                    <img src={require('./../assets/background/iphone.png').default} className="phoneImg" alt=""/>
                                    <img className="backImg" src={item.image} alt=""/>
                                    <div className="itemLeft">
                                        <p className="itemTittle">{item.name}</p>
                                        <div className='containerRow'>
                                            <p className="line"></p>
                                            <a className="downloadButton"
                                               href={item.link}>立即下载</a>
                                        </div>
                                        <span className="descText">{item.content}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </Carousel>
            </div>
        </div>
    )

}

export default Product
